import * as React from "react";
import Face from "../face";
import { FontWeightProperty } from "csstype";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDiceOne, faDiceTwo, faDiceThree, faDiceFour, faDiceFive, faDiceSix, faTimesCircle, IconDefinition, faCertificate } from '@fortawesome/free-solid-svg-icons'
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

interface FaceProps {
    face: Face;
    dieIndex: number;
    currentRoll: boolean;
    selectedRoll: boolean;
}

const pipValueToString = (value: number): IconDefinition => {
    switch (value) {
        case 1: return faDiceOne;
        case 2: return faDiceTwo;
        case 3: return faDiceThree;
        case 4: return faDiceFour;
        case 5: return faDiceFive;
        case 6: return faDiceSix;
        default: throw new Error();
    }
}

export const dieFaceToElement = (face: Face, size: SizeProp): JSX.Element => {
    switch (face.type) {
        case "Pips":
            return <FontAwesomeIcon icon={pipValueToString(face.value)} fixedWidth size={size} />;
        case "Vp":
            var fontWeight900: FontWeightProperty = 900;
            var fontWeightStyle = { fontWeight: fontWeight900 };
            return <span className={"fa-layers fa-fw fa-" + size}>
                <FontAwesomeIcon icon={faCertificate} color="green" />
                <span className="fa-layers-text fa-inverse" data-fa-transform="shrink-12 down-3" style={fontWeightStyle}>{face.value}</span>
            </span>;
        case "X":
            return <FontAwesomeIcon icon={faTimesCircle} fixedWidth size={size} color="red" />;
        default:
            throw new Error();
    }
}

const DieFaceDisplay: React.SFC<FaceProps> = (props) => {
    var highlightClass = "unrolled";
    if (props.currentRoll) {
        highlightClass = "rolled";
    }
    if (props.selectedRoll) {
        highlightClass = "selected";
    }
    return <div className={"die die" + props.dieIndex + " " + highlightClass}>{dieFaceToElement(props.face, "4x")}</div>;
}

export default DieFaceDisplay;